<template>
    <div>
        <van-popup v-model="show" @click-overlay="close">
            <div class="tips_pop">
                <div class="tips_top">
                    <!-- <div class="tips_close" @click="close">
                        <i class="iconfont icon-s-cuowu-guanbi"></i>
                    </div> -->
                </div>
                <div class="tips_box">
                    <div class="tips_title">
                        <img src="https://laranja9.sorte99bet.com/dev/sorteebet/img/1778842067811-hua.png" />
                    </div>
                    <div class="tips">{{ $t("RedemptionCode.tips1") }}</div>
                    <a-input v-model="code" :placeholder="$t('RedemptionCode.PleaseEnterTheRedemptionCode')"></a-input>
                    <div class="platforms_icons">
                        <img v-for="(item, index) in platforms.slice(0, 3)" :key="index" :src="item.icon" @click="onNavTo({ url: item.url, type: 'href' })" />
                    </div>
                </div>
                <div class="tips_footer" @click="confirm">
                    {{ $t("RedemptionCode.exchange") }}
                </div>
            </div>
            <div class="close_btn" @click="close">
                <i class="iconfont icon-s-cuowu-guanbi"></i>
            </div>
        </van-popup>
        <upBonusPopup ref="upBonusPopup" @getNormalReward="onReceiveReward"></upBonusPopup>
    </div>
</template>

<script>
import { getDrawDown, getRedEnvelopeDetail } from '@/api/bonusCenter'
import upBonusPopup from '@/views/weeklySalary/modules/upBonusPopup.vue'
import { Toast } from 'vant'
export default {
    props: {
        tips: {
            type: String,
            default: ''
        },
        tips2: {
            type: String,
            default: ''
        }
    },
    components: { upBonusPopup },
    computed: {
        sysConfig() {
            return this.$store.getters.sysConfig
        }
    },
    watch: {
        sysConfig: {
            handler: function (newVal, oldVal) {
                if (newVal) {
                    this.GetPlatforms()
                }
            },
            deep: true,
            immediate: true
        }
    },
    data() {
        return {
            show: false,
            code: '',
            platforms: [],
            isCanReceiveReward: true
        }
    },
    methods: {
        close() {
            this.show = false
            this.$emit('close')
        },
        open() {
            this.show = true
            const code = this.$store.state.user.redEnvelopeCode
            if (code) this.code = code
            this.GetPlatforms()
        },
        confirm() {
            const that = this
            if (!that.code) {
                Toast(that.$t('RedemptionCode.PleaseEnterTheRedemptionCode2'))
                return
            }
            const params = {
                code: that.code.trim()
            }
            getRedEnvelopeDetail(params).then((res1) => {
                if (res1.code) return
                const D1 = res1.result
                if (D1.bonusCanLevelUp === 'Yes') {
                    const item = {
                        type: 'redEnvelope',
                        amount: D1.singleAmt,
                        levelUpAmount: D1.bonusLevelUpBonusAmt,
                        rewardRecordId: D1.redEnvelopeId,
                        rewardState: 'canClaim',
                        upgradeBonusLevelUpRechargeAmt: D1.bonusLevelUpRechargeAmt,
                        depositType: 'redEnvelope'
                    }
                    that.$refs.upBonusPopup.open(item)
                } else {
                    that.onReceiveReward()
                    that.$emit('confirm')
                }
            })
        },
        onReceiveReward() {
            const that = this
            if (that.isCanReceiveReward) {
                that.isCanReceiveReward = false
                const params = {
                    code: that.code.trim()
                }
                getDrawDown(params).then((res) => {
                    if (res.code) return
                    that.$store.dispatch('user/setRedEnvelopeCode', '')
                    that.close()
                    Toast(res.message)
                }).finally(() => {
                    that.isCanReceiveReward = true
                })
            }
        },
        GetPlatforms() {
            this.platforms = []
            const systemConfig = this.sysConfig
            if (!systemConfig) return
            const whatsapp = systemConfig.whatsapp?.trim()
            if (whatsapp) {
                const platform5 = {
                    id: 4,
                    icon: require('@/assets/share/icon_whatsapp.png'),
                    title: 'Whatsapp',
                    url: whatsapp,
                    linkType: 'href'
                }
                this.platforms.push(platform5)
            }
            const telegramGroup = systemConfig.telegramGroup?.trim()
            if (telegramGroup) {
                const platform8 = {
                    id: 1,
                    icon: require('@/assets/share/icon_telegram.png'),
                    title: 'Telegram',
                    url: telegramGroup,
                    linkType: 'href'
                }
                this.platforms.push(platform8)
            }
            const instagram = systemConfig.instagram?.trim()
            if (instagram) {
                const platform3 = {
                    id: 2,
                    icon: require('@/assets/share/icon_ins.png'),
                    title: 'Instagram',
                    url: instagram,
                    linkType: 'href'
                }
                this.platforms.push(platform3)
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';
.van-popup {
    background: transparent;
    width: 100%;
}

.close_btn {
    width: .8rem;
    height: .8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: $bg-list-th-color;
    margin: .3rem auto;
    border-radius: .1rem;
    border: 1px solid rgba($border-active-color, .6);
    cursor: pointer;
    .iconfont {
        font-size: .4rem;
        color: $font-title-color;
    }
}

.tips_pop {
        position: relative;
        background: $bg-popup-color;
        // background-image: url('@/assets/common/left1.png'),
        //     /* 左上角 */
        //     url('@/assets/common/right1.png'),
        //     /* 右上角 */
        //     url('@/assets/common/left2.png'),
        //     /* 左下角 */
        //     url('@/assets/common/right2.png');
        /* 右下角 */

        /* 四个角位置 ↓ 一一对应 */
        // background-position: left top,
        //     right top,
        //     left bottom,
        //     right bottom;

        /* 不重复 */
        background-repeat: no-repeat;

        /* 图片大小（根据你需求调整） */
        // background-size: 2.25rem 1.5rem;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            pointer-events: none;
            background-image:
                linear-gradient(to bottom, transparent 0%, rgba($border-active-color, .36) 10%, $font-theme-color 50%, rgba($border-active-color, .36) 85%, transparent 100%),
                linear-gradient(to bottom, transparent 0%, rgba($border-active-color, .36) 10%, $font-theme-color 50%, rgba($border-active-color, .36) 85%, transparent 100%);
            background-position: left center, right center;
            background-size: 0.04rem 100%, 0.04rem 100%;
            background-repeat: no-repeat;
        }

        &::after {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            pointer-events: none;
            background-image:
                linear-gradient(to right, transparent 0%, rgba($border-active-color, .36) 15%, $font-theme-color 50%, rgba($border-active-color, .36) 85%, transparent 100%),
                linear-gradient(to right, transparent 0%, rgba($border-active-color, .36) 15%, $font-theme-color 50%, rgba($border-active-color, .36) 85%, transparent 100%);
            background-position: center top, center bottom;
            background-size: 100% 0.04rem, 100% 0.04rem;
            background-repeat: no-repeat;
        }
    }

.tips_pop {
    padding: .26rem .46rem;
    width: 94%;
    max-width: 8rem;
    border-radius: .2rem;
    margin: 0 auto;
    padding-bottom: .06rem;
    height: auto;

    .tips_top {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        // margin: 0 .3rem;
        position: relative;
        z-index: 0;
        height: 1rem;

        .tips_close {
            width: .42rem;
            height: .42rem;
            cursor: pointer;
            color: $font-color;
            position: absolute;
            right: -.22rem;
            top: 0;
            i{
                font-size: .38rem;
                font-weight: 400;
            }
        }
    }

    .tips_box {
        font-size: .24rem;
        padding:  0 .5rem;
        position: relative;
        z-index: 1;
        background: rgba($bg-list-color, .72);
        box-shadow: inset 8px 8px 30px 0px rgba($font-theme-color, .12), inset -8px -8px 30px 0px rgba($font-label-color, .16);
        border-radius: .3rem;
        border: 2px solid rgba($border-active-color, .45);

        .tips_title {
            width: 3rem;
            margin: -1rem auto 0 auto;
            & > img{
                width: 100%;
                height: auto;
            }
        }

        .tips{
            text-align: left;
            color: $font-sub-color;
            font-size: .24rem;
            font-weight: bold;
            margin-bottom: .2rem;
            box-sizing: border-box;
        }

        .platforms_icons{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: .28rem 0;
            gap: .3rem;
            margin-bottom: .52rem;

            & > img{
                width: .88rem;
                height: .88rem;
            }
        }

        .tips2 {
            margin-top: .2rem;
        }

        ::v-deep input::-webkit-outer-spin-button {
            -webkit-appearance: none;
        }

        ::v-deep input::-webkit-inner-spin-button {
            -webkit-appearance: none;
        }

        ::v-deep input[type='number'] {
            -moz-appearance: textfield;
        }

        ::v-deep .ant-input {
            background: $bg-input-color !important;
            border-radius: 0.14rem;
            font-size: 0.32rem;
            height: .8rem;
            padding: 0px 0.24rem !important;
            color: $font-color;
            border: .02rem solid $border-input-color !important;
            padding-left: .2rem !important;

            &:focus {
                background: $bg-input-act-color;
                border-color: $border-active-color !important;
            }

            &::-webkit-input-placeholder {
                /* WebKit browsers */
                font-size: .32rem;
                color: $font-placeholder-color;
                opacity: .7;
                font-weight: 100;
            }

            &:-moz-placeholder {
                /* Mozilla Firefox 4 to 18 */
                font-size: .32rem;
                color: $font-placeholder-color;
            }

            &::-moz-placeholder {
                /* Mozilla Firefox 19+ */
                font-size: .32rem;
                color: $font-placeholder-color;
            }

            &:-ms-input-placeholder {
                /* Internet Explorer 10+ */
                font-size: .32rem;
                color: $font-placeholder-color;
            }

        }
    }

    .tips_footer {
        padding: 0 .5rem;
        width: fit-content;
        box-sizing: border-box;
        height: .8rem;
        background: $bg-btn-color;
        line-height: .73rem;
        text-align: center;
        font-size: .4rem;
        color: $font-btn-color;
        margin: .5rem auto;
        cursor: pointer;
        border-radius: .9rem;
        background: $bg-home-popup-button-color;
        box-shadow: 0px 4px 4px 0px rgba($font-label-color, .3);
    }
}
</style>
